<template>
  <v-container>
    <v-form ref="form" :value="valid" @submit.prevent="submit" lazy-validation>
      <h1>Fiche fournisseur {{ nom }}</h1>
      <h2>Coordonnées siège social</h2>
      <v-textarea
        v-model="adresseSiegeLigne1"
        label="Adresse 1"
        hint="N°, voie et nom de la voie"
        rows="3"
        auto-grow
        clearable
        filled
      ></v-textarea>
      <v-textarea
        v-model="adresseSiegeLigne2"
        label="Adresse 2"
        filled
        hint="Boîte postale, Zone, complément adresse"
        rows="3"
        auto-grow
        clearable
      ></v-textarea>
      <v-text-field
        v-model="adresseSiegeCodePostal"
        label="Code Postal"
        required
        filled
        :error-messages="adresseSiegeCodePostalErrors"
        @input="$v.adresseSiegeCodePostal.$touch()"
        @blur="$v.adresseSiegeCodePostal.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseSiegeVille"
        label="Ville"
        filled
        counter="50"
        required
        :error-messages="adresseSiegeVilleErrors"
        @input="$v.adresseSiegeVille.$touch()"
        @blur="$v.adresseSiegeVille.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseSiegeTelephone"
        label="Téléphone"
        filled
        :error-messages="adresseSiegeTelephoneErrors"
        @input="$v.adresseSiegeTelephone.$touch()"
        @blur="$v.adresseSiegeTelephone.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseSiegeFax"
        label="Fax"
        filled
        counter="20"
        :error-messages="adresseSiegeFaxErrors"
        @input="$v.adresseSiegeFax.$touch()"
        @blur="$v.adresseSiegeFax.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseEmail"
        label="e-mail"
        filled
        counter="80"
        :error-messages="emailErrors"
        @input="$v.adresseEmail.$touch()"
        @blur="$v.adresseEmail.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="urlSiteWeb"
        label="Site Internet"
        counter="80"
        filled
        hint="Format: https://www.exemple.fr"
        :error-messages="urlSiteWebErrors"
        @input="$v.urlSiteWeb.$touch()"
        @blur="$v.urlSiteWeb.$touch()"
      ></v-text-field>

      <h2>Adresse commandes</h2>
      <v-textarea
        v-model="adresseCommandeLigne1"
        label="Adresse 1"
        name="commandesAdresse1"
        filled
        hint="N°, voie et nom de la voie"
        rows="3"
        auto-grow
        clearable
      ></v-textarea>
      <v-textarea
        v-model="adresseCommandeLigne2"
        label="Adresse 2"
        name="commandeAdresse2"
        filled
        hint="Boîte postale, Zone, complément adresse"
        rows="3"
        auto-grow
        clearable
      ></v-textarea>
      <v-text-field
        v-model="adresseCommandeCodePostal"
        label="Code Postal"
        filled
        required
        :error-messages="adresseCommandeCodePostalErrors"
        @input="$v.adresseCommandeCodePostal.$touch()"
        @blur="$v.adresseCommandeCodePostal.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseCommandeVille"
        label="Ville"
        counter="50"
        filled
        required
        :error-messages="adresseCommandeVilleErrors"
        @input="$v.adresseCommandeVille.$touch()"
        @blur="$v.adresseCommandeVille.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseCommandeTelephone"
        label="Téléphone"
        filled
        counter="20"
        :error-messages="adresseCommandeTelephoneErrors"
        @input="$v.adresseCommandeTelephone.$touch()"
        @blur="$v.adresseCommandeTelephone.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="adresseCommandeFax"
        label="Fax"
        filled
        counter="20"
        :error-messages="adresseCommandeFaxErrors"
        @input="$v.adresseCommandeFax.$touch()"
        @blur="$v.adresseCommandeFax.$touch()"
      ></v-text-field>

      <h2>Direction</h2>
      <v-text-field
        v-model="directeurGeneral"
        label="Direction générale"
        filled
        counter="50"
        :error-messages="directeurGeneralErrors"
        @input="$v.directeurGeneral.$touch()"
        @blur="$v.directeurGeneral.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="directeurCommercial"
        label="Direction commerciale"
        :error-messages="directeurCommercialErrors"
        filled
        counter="50"
        @input="$v.directeurCommercial.$touch()"
        @blur="$v.directeurCommercial.$touch()"
      ></v-text-field>
      <h2>Responsable matériovigilance</h2>
      <v-text-field
        v-model="responsableMaterioVigilanceNom"
        label="Nom"
        filled
        counter="50"
        :error-messages="responsableMaterioVigilanceNomErrors"
        @input="$v.responsableMaterioVigilanceNom.$touch()"
        @blur="$v.responsableMaterioVigilanceNom.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="responsableMaterioVigilanceTelephone"
        label="Téléphone"
        filled
        counter="20"
        :error-messages="responsableMaterioVigilanceTelephoneErrors"
        @input="$v.responsableMaterioVigilanceTelephone.$touch()"
        @blur="$v.responsableMaterioVigilanceTelephone.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="responsableMaterioVigilanceFax"
        label="Fax"
        filled
        counter="20"
        :error-messages="responsableMaterioVigilanceFaxErrors"
        @input="$v.responsableMaterioVigilanceFax.$touch()"
        @blur="$v.responsableMaterioVigilanceFax.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="responsableMaterioVigilanceAdresseEmail"
        label="e-mail"
        filled
        counter="80"
        :error-messages="responsableMaterioVigilanceAdresseEmailErrors"
        @input="$v.responsableMaterioVigilanceAdresseEmail.$touch()"
        @blur="$v.responsableMaterioVigilanceAdresseEmail.$touch()"
      ></v-text-field>

      <v-row>
        <v-col class="align-self-center">
          <h2>Certification</h2>
        </v-col>
        <v-col cols="1" class="align-self-center text-right">
          <v-switch v-model="withCertif" inset></v-switch>
        </v-col>
      </v-row>
      <v-text-field
        v-model="certificationNom"
        label="Certification"
        filled
        counter="50"
        :disabled="!withCertif"
        :error-messages="certificationNomErrors"
        @input="$v.certificationNom.$touch()"
        @blur="$v.certificationNom.$touch()"
      ></v-text-field>
      <v-menu
        v-model="showCertifDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :disabled="!withCertif"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="certificationDateObtentionTF"
            filled
            label="Date obtention"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :disabled="!withCertif"
            :error-messages="certificationDateObtentionErrors"
            @blur="
              certificationDateObtention = parseDate(
                certificationDateObtentionTF
              )
            "
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="certificationDateObtention"
          :max="new Date().toISOString()"
          @input="showCertifDate = false"
        ></v-date-picker>
      </v-menu>
      <v-text-field
        v-model="certificationOrganisme"
        label="Organisme"
        filled
        counter="100"
        :disabled="!withCertif"
        :error-messages="certificationOrganismeErrors"
        @input="$v.certificationOrganisme.$touch()"
        @blur="$v.certificationOrganisme.$touch()"
      ></v-text-field>

      <h2>Accès au site demandes Euro-Pharmat</h2>
      <v-text-field
        v-model="logon"
        label="Login Administrateur"
        filled
        counter="30"
        :error-messages="logonErrors"
        @input="$v.logon.$touch()"
        @blur="$v.logon.$touch()"
      >
        <template v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="secondary"
                dark
                v-bind="attrs"
                v-on="on"
                @click.stop="resetPassword(1)"
              >
                mdi-lock-reset
              </v-icon>
            </template>
            <span>Réinitialiser le mot de passe</span>
          </v-tooltip>
        </template>
      </v-text-field>
      <v-text-field
        v-model="logonLimite"
        label="Login restreint aux demandes"
        filled
        counter="30"
        :error-messages="logonLimiteErrors"
        @input="$v.logonLimite.$touch()"
        @blur="$v.logonLimite.$touch()"
      >
        <template v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="secondary"
                dark
                v-bind="attrs"
                v-on="on"
                @click.stop="resetPassword(2)"
              >
                mdi-lock-reset
              </v-icon>
            </template>
            <span>Réinitialiser le mot de passe</span>
          </v-tooltip>
        </template></v-text-field
      >
      <v-text-field
        v-model="adresseMailDemandes"
        label="e-mail demandes"
        filled
        counter="80"
        :error-messages="adresseMailDemandesErrors"
        @input="$v.adresseMailDemandes.$touch()"
        @blur="$v.adresseMailDemandes.$touch()"
      ></v-text-field>
      <h2>Logo fournisseur pour fiches DM</h2>

      <div v-if="!logoSupprime">
        <v-img
          v-for="ext in logoExtensions"
          :key="ext"
          contain
          max-width="150"
          max-height="100"
          :src="
            cheminLogos +
            $store.state.identite.fournisseur.id.toString() +
            '.' +
            ext +
            '?hmac=' +
            Date.now().toString(36) +
            Math.random().toString(36).substring(2)
          "
        >
          <v-overlay
            :absolute="true"
            :value="true"
            style="
              background: none;
              justify-content: end;
              align-items: start;
              width: 100%;
            "
            opacity="0"
          >
            <v-tooltip right color="red" dark>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="red"
                  @click="logoSupprime = true"
                  v-bind="attrs"
                  v-on="on"
                  >mdi-trash-can
                </v-icon>
              </template>
              <span>Supprimer le logo</span>
            </v-tooltip>
          </v-overlay>
        </v-img>
      </div>
      <v-file-input
        v-model="logo"
        label="Fichier image"
        filled
        show-size
        truncate-length="30"
        prepend-icon="mdi-panorama-variant"
        accept="image/jpeg,image/png,image/gif,image/svg"
        hint="Ce fichier remplacera le logo actuel s'il y en a un"
        :error-messages="logoErrors"
        @input="$v.logo.$touch()"
        @blur="$v.logo.$touch()"
      ></v-file-input>

      <v-btn :disabled="!valid" type="submit" color="success" class="mr-4">
        Mettre à jour
      </v-btn>
      <v-btn color="error" class="mr-4" @click="cancel"> Annuler </v-btn>

      <change-password
        :show="showResetPass"
        @hide="showResetPass = false"
        :passwordKind="passwordKind"
      ></change-password> </v-form
  ></v-container>
</template>

<script>
import ChangePassword from "@/components/ChangePassword";
import FournisseurService from "@/services/FournisseurService";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  url,
  requiredIf,
  not,
  sameAs,
} from "vuelidate/lib/validators";
import {
  phoneCharacters,
  beforeToday,
  maxFileSize,
} from "@/validators/validators.js";
export default {
  name: "AccountView",
  components: {
    ChangePassword,
  },
  mixins: [validationMixin],
  data() {
    return {
      logoSupprime: false,
      // actualLogoUrl: "",
      logoExtensions: ["png", "jpg", "jpeg", "svg", "gif"],
      nom: "",
      adresseEmail: "",
      adresseMailDemandes: "",
      directeurCommercial: "",
      directeurGeneral: "",
      logon: "",
      logonLimite: "",
      urlSiteWeb: "",
      adresseSiegeLigne1: "",
      adresseSiegeLigne2: "",
      adresseSiegeCodePostal: "",
      adresseSiegeVille: "",
      adresseSiegeTelephone: "",
      adresseSiegeFax: "",
      adresseCommandeLigne1: "",
      adresseCommandeLigne2: "",
      adresseCommandeCodePostal: "",
      adresseCommandeVille: "",
      adresseCommandeTelephone: "",
      adresseCommandeFax: "",
      certificationDateObtention: null,
      certificationDateObtentionTF: null,
      certificationNom: "",
      certificationOrganisme: "",
      responsableMaterioVigilanceNom: "",
      responsableMaterioVigilanceTelephone: "",
      responsableMaterioVigilanceFax: "",
      responsableMaterioVigilanceAdresseEmail: "",
      withCertif: true,
      showCertifDate: false,
      showResetPass: false,
      passwordKind: 0,
      logo: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    FournisseurService.getAccountInfo()
      .then((res) => {
        let frn = res.data;
        next((vm) => {
          // console.log(vm);
          // console.log(frn);

          //let frn = this.fournisseur;
          for (let prop in frn) {
            if (typeof frn[prop] === "object") {
              for (let prop2 in frn[prop]) {
                vm[
                  `${prop}${prop2.charAt(0).toUpperCase()}${prop2.substring(1)}`
                ] = frn[prop][prop2];
              }
            } else {
              vm[prop] = frn[prop];
            }
          }
          vm.withCertif = vm.certificationNom != "";
          vm.certificationDateObtentionTF = vm.formatDate(
            vm.certificationDateObtention
          );
        });
      })
      .catch((err) => {
        // console.log("In promise error handler");
        if (err.response && err.response.status && err.response.status == 401) {
          next({ name: "home" });
        } else if (err instanceof Error) {
          // console.log("About to call next(err)");
          let errorToPropagate = new Error();
          errorToPropagate.originalError = err;
          next(errorToPropagate);
        }
      });
  },
  mounted() {
    this.$v.$touch();
  },
  watch: {
    withCertif() {
      if (!this.withCertif) {
        this.certificationDateObtention = "";
        this.certificationNom = "";
        this.certificationOrganisme = "";
      }
    },
    certificationDateObtention() {
      this.certificationDateObtentionTF = this.formatDate(
        this.certificationDateObtention
      );
    },
  },
  computed: {
    cheminLogos() {
      return process.env.VUE_APP_CHEMIN_LOGOS_FRNS;
    },
    valid() {
      return !this.$v.$invalid;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.adresseEmail.$dirty) return errors;
      !this.$v.adresseEmail.email && errors.push("Format invalide");
      !this.$v.adresseEmail.maxLength &&
        errors.push("80 caractères au maximum");
      return errors;
    },
    adresseSiegeCodePostalErrors() {
      const errors = [];
      if (!this.$v.adresseSiegeCodePostal.$dirty) return errors;
      !this.$v.adresseSiegeCodePostal.required && errors.push("Obligatoire");
      (!this.$v.adresseSiegeCodePostal.minLength ||
        !this.$v.adresseSiegeCodePostal.maxLength) &&
        errors.push("Doit être composé de 2 à 8 caractères");
      return errors;
    },
    adresseSiegeVilleErrors() {
      const errors = [];
      if (!this.$v.adresseSiegeVille.$dirty) return errors;
      !this.$v.adresseSiegeVille.required && errors.push("Obligatoire");
      !this.$v.adresseSiegeVille.maxLength &&
        errors.push("50 caractères au maximum");
      return errors;
    },
    adresseSiegeTelephoneErrors() {
      const errors = [];
      if (!this.$v.adresseSiegeTelephone.$dirty) return errors;
      (!this.$v.adresseSiegeTelephone.maxLength ||
        !this.$v.adresseSiegeTelephone.minLength) &&
        errors.push("Doit être composé de 5 à 20 caractères");
      !this.$v.adresseSiegeTelephone.phoneCharacters &&
        errors.push(
          "Caractères autorisés: chiffres, espaces, parenthèses, + et -"
        );
      return errors;
    },
    adresseSiegeFaxErrors() {
      const errors = [];
      if (!this.$v.adresseSiegeFax.$dirty) return errors;
      (!this.$v.adresseSiegeFax.maxLength ||
        !this.$v.adresseSiegeFax.minLength) &&
        errors.push("Doit être composé de 5 à 20 caractères");
      !this.$v.adresseSiegeFax.phoneCharacters &&
        errors.push(
          "Caractères autorisés: chiffres, espaces, parenthèses, + et -"
        );
      return errors;
    },
    urlSiteWebErrors() {
      const errors = [];
      if (!this.$v.urlSiteWeb.$dirty) return errors;
      !this.$v.urlSiteWeb.url && errors.push("Format invalide");
      !this.$v.urlSiteWeb.maxLength && errors.push("80 caractères au maximum");
      return errors;
    },
    adresseCommandeCodePostalErrors() {
      const errors = [];
      if (!this.$v.adresseCommandeCodePostal.$dirty) return errors;
      !this.$v.adresseCommandeCodePostal.required && errors.push("Obligatoire");
      (!this.$v.adresseCommandeCodePostal.minLength ||
        !this.$v.adresseCommandeCodePostal.maxLength) &&
        errors.push("Doit être composé de 2 à 8 caractères");
      return errors;
    },
    adresseCommandeVilleErrors() {
      const errors = [];
      if (!this.$v.adresseCommandeVille.$dirty) return errors;
      !this.$v.adresseCommandeVille.required && errors.push("Obligatoire");
      !this.$v.adresseCommandeVille.maxLength &&
        errors.push("50 caractères au maximum");
      return errors;
    },
    adresseCommandeTelephoneErrors() {
      const errors = [];
      if (!this.$v.adresseCommandeTelephone.$dirty) return errors;
      (!this.$v.adresseCommandeTelephone.maxLength ||
        !this.$v.adresseCommandeTelephone.minLength) &&
        errors.push("Doit être composé de 5 à 20 caractères");
      !this.$v.adresseCommandeTelephone.phoneCharacters &&
        errors.push(
          "Caractères autorisés: chiffres, espaces, parenthèses, + et -"
        );
      return errors;
    },
    adresseCommandeFaxErrors() {
      const errors = [];
      if (!this.$v.adresseCommandeFax.$dirty) return errors;
      (!this.$v.adresseCommandeFax.maxLength ||
        !this.$v.adresseCommandeFax.minLength) &&
        errors.push("Doit être composé de 5 à 25 caractères");
      !this.$v.adresseCommandeFax.phoneCharacters &&
        errors.push(
          "Caractères autorisés: chiffres, espaces, parenthèses, + et -"
        );
      return errors;
    },
    directeurGeneralErrors() {
      const errors = [];
      if (!this.$v.directeurGeneral.$dirty) return errors;
      (!this.$v.directeurGeneral.maxLength ||
        !this.$v.directeurGeneral.minLength) &&
        errors.push("Doit être composé de 4 à 50 caractères");
      return errors;
    },
    directeurCommercialErrors() {
      const errors = [];
      if (!this.$v.directeurCommercial.$dirty) return errors;
      (!this.$v.directeurCommercial.maxLength ||
        !this.$v.directeurCommercial.minLength) &&
        errors.push("Doit être composé de 4 à 50 caractères");
      return errors;
    },
    responsableMaterioVigilanceNomErrors() {
      const errors = [];
      if (!this.$v.responsableMaterioVigilanceNom.$dirty) return errors;
      (!this.$v.responsableMaterioVigilanceNom.maxLength ||
        !this.$v.responsableMaterioVigilanceNom.minLength) &&
        errors.push("Doit être composé de 4 à 50 caractères");
      return errors;
    },
    responsableMaterioVigilanceTelephoneErrors() {
      const errors = [];
      if (!this.$v.responsableMaterioVigilanceTelephone.$dirty) return errors;
      (!this.$v.responsableMaterioVigilanceTelephone.maxLength ||
        !this.$v.responsableMaterioVigilanceTelephone.minLength) &&
        errors.push("Doit être composé de 5 à 20 caractères");
      !this.$v.responsableMaterioVigilanceTelephone.phoneCharacters &&
        errors.push(
          "Caractères autorisés: chiffres, espaces, parenthèses, + et -"
        );
      return errors;
    },
    responsableMaterioVigilanceFaxErrors() {
      const errors = [];
      if (!this.$v.responsableMaterioVigilanceFax.$dirty) return errors;
      (!this.$v.responsableMaterioVigilanceFax.maxLength ||
        !this.$v.responsableMaterioVigilanceFax.minLength) &&
        errors.push("Doit être composé de 5 à 20 caractères");
      !this.$v.responsableMaterioVigilanceFax.phoneCharacters &&
        errors.push(
          "Caractères autorisés: chiffres, espaces, parenthèses, + et -"
        );
      return errors;
    },
    responsableMaterioVigilanceAdresseEmailErrors() {
      const errors = [];
      if (!this.$v.responsableMaterioVigilanceAdresseEmail.$dirty)
        return errors;
      !this.$v.responsableMaterioVigilanceAdresseEmail.email &&
        errors.push("Format invalide");
      !this.$v.responsableMaterioVigilanceAdresseEmail.maxLength &&
        errors.push("80 caractères au maximum");
      return errors;
    },
    certificationNomErrors() {
      const errors = [];
      if (!this.$v.certificationNom.$dirty) return errors;
      !this.$v.certificationNom.requiredIf && errors.push("Obligatoire");
      (!this.$v.certificationNom.maxLength ||
        !this.$v.certificationNom.minLength) &&
        errors.push("Doit être composé de 2 à 50 caractères");

      return errors;
    },
    certificationOrganismeErrors() {
      const errors = [];
      if (!this.$v.certificationOrganisme.$dirty) return errors;
      !this.$v.certificationOrganisme.requiredIf && errors.push("Obligatoire");
      !this.$v.certificationOrganisme.minLength &&
        errors.push("2 caractères au minimum");
      !this.$v.certificationOrganisme.maxLength &&
        errors.push("100 caractères au maximum");
      return errors;
    },
    certificationDateObtentionErrors() {
      const errors = [];
      if (!this.$v.certificationDateObtention.$dirty) return errors;
      !this.$v.certificationDateObtention.requiredIf &&
        errors.push("Obligatoire");
      !this.$v.certificationDateObtention.beforeToday &&
        errors.push("Doit être antérieure à aujourd'hui");
      return errors;
    },
    logonErrors() {
      const errors = [];
      if (!this.$v.logon.$dirty) return errors;
      !this.$v.logon.required && errors.push("Obligatoire");
      (!this.$v.logon.maxLength || !this.$v.logon.minLength) &&
        errors.push("Doit être composé de 3 à 30 caractères");
      return errors;
    },
    logonLimiteErrors() {
      const errors = [];
      if (!this.$v.logonLimite.$dirty) return errors;
      (!this.$v.logonLimite.maxLength || !this.$v.logonLimite.minLength) &&
        errors.push("Doit être composé de 3 à 30 caractères");
      !this.$v.logonLimite.notSameAsLogon &&
        errors.push("Doit être différent du login administrateur");
      return errors;
    },
    adresseMailDemandesErrors() {
      const errors = [];
      if (!this.$v.adresseMailDemandes.$dirty) return errors;
      !this.$v.adresseMailDemandes.required && errors.push("Obligatoire");
      !this.$v.adresseMailDemandes.email && errors.push("Format invalide");
      !this.$v.adresseMailDemandes.maxLength &&
        errors.push("80 caractères au maximum");
      return errors;
    },
    logoErrors() {
      const errors = [];
      if (!this.$v.logo.$dirty) return errors;
      !this.$v.logo.maxFileSize && errors.push("Taille maximale: 500Ko");
      return errors;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    submit() {
      this.$v.$touch();
      // console.log(this.valid);
      if (!this.$v.$invalid) {
        let logoProm = null;

        // D'abord le logo si nécessaire
        if (this.logo) {
          logoProm = FournisseurService.updateLogo(this.logo);
        } else if (this.logoSupprime) {
          logoProm = FournisseurService.deleteLogo();
        }

        // Ensuite les informations du fournisseur
        let payload = {
          estAdherant: true,
          id: this.$store.state.identite.fournisseur.id,
          nom: this.$store.state.identite.fournisseur.nom,
          logon: this.logon,
          logonLimite: this.logonLimite,
          adresseMailDemandes: this.adresseMailDemandes,
          adresseEmail: this.adresseEmail,
          urlSiteWeb: this.urlSiteWeb,
          directeurGeneral: this.directeurGeneral,
          directeurCommercial: this.directeurCommercial,
          responsableMaterioVigilance: {
            nom: this.responsableMaterioVigilanceNom,
            telephone: this.responsableMaterioVigilanceTelephone,
            fax: this.responsableMaterioVigilanceFax,
            adresseEmail: this.responsableMaterioVigilanceAdresseEmail,
          },

          adresseSiege: {
            ligne1: this.adresseSiegeLigne1,
            ligne2: this.adresseSiegeLigne2,
            codePostal: this.adresseSiegeCodePostal,
            ville: this.adresseSiegeVille,
            telephone: this.adresseSiegeTelephone,
            fax: this.adresseSiegeFax,
          },
          adresseCommande: {
            ligne1: this.adresseCommandeLigne1,
            ligne2: this.adresseCommandeLigne2,
            codePostal: this.adresseCommandeCodePostal,
            ville: this.adresseCommandeVille,
            telephone: this.adresseCommandeTelephone,
            fax: this.adresseCommandeFax,
          },
        };
        if (this.withCertif) {
          payload.certification = {
            dateObtention: this.certificationDateObtention,
            nom: this.certificationNom,
            organisme: this.certificationOrganisme,
          };
        }
        Promise.all([logoProm, FournisseurService.update(payload)])
          .then(() => {
            this.$router.push({ name: "menu" });
          })
          .catch((err) => {
            this.$store.dispatch("setErreur", err);
          });
      }
    },
    cancel() {
      this.$router.push({ name: "menu" });
    },
    resetPassword(kind) {
      this.passwordKind = kind;
      this.showResetPass = true;
    },
  },
  validations: {
    adresseSiegeCodePostal: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(8),
    },
    adresseSiegeVille: {
      required,
      maxLength: maxLength(50),
    },
    adresseSiegeTelephone: {
      minLength: minLength(5),
      maxLength: maxLength(25),
      phoneCharacters,
    },
    adresseSiegeFax: {
      minLength: minLength(5),
      maxLength: maxLength(25),
      phoneCharacters,
    },
    adresseEmail: {
      email,
      maxLength: maxLength(80),
    },
    urlSiteWeb: {
      url,
      maxLength: maxLength(80),
    },
    adresseCommandeCodePostal: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(8),
    },
    adresseCommandeVille: {
      required,
      maxLength: maxLength(50),
    },
    adresseCommandeTelephone: {
      minLength: minLength(5),
      maxLength: maxLength(25),
      phoneCharacters,
    },
    adresseCommandeFax: {
      minLength: minLength(5),
      maxLength: maxLength(25),
      phoneCharacters,
    },
    directeurGeneral: {
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
    directeurCommercial: {
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
    responsableMaterioVigilanceNom: {
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
    responsableMaterioVigilanceTelephone: {
      minLength: minLength(5),
      maxLength: maxLength(20),
      phoneCharacters,
    },
    responsableMaterioVigilanceFax: {
      minLength: minLength(5),
      maxLength: maxLength(20),
      phoneCharacters,
    },
    responsableMaterioVigilanceAdresseEmail: {
      email,
      maxLength: maxLength(80),
    },
    certificationDateObtention: {
      requiredIf: requiredIf("withCertif"),
      beforeToday,
    },
    certificationNom: {
      requiredIf: requiredIf("withCertif"),
      minLength: minLength(2),
      maxLength: maxLength(50),
    },
    certificationOrganisme: {
      requiredIf: requiredIf("withCertif"),
      minLength: minLength(2),
      maxLength: maxLength(100),
    },
    logon: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(30),
    },
    logonLimite: {
      minLength: minLength(3),
      maxLength: maxLength(30),
      notSameAsLogon: not(sameAs("logon")),
    },
    adresseMailDemandes: {
      required,
      email,
      maxLength: maxLength(80),
    },
    logo: {
      maxFileSize: maxFileSize(500000),
    },
  },
};
</script>

<style>
.v-card--reveal {
  justify-content: end;
  align-items: start;
  bottom: 0;
  opacity: 0;
  position: absolute;
  width: 180px;
}
</style>
